/**
 * 摄像头管理 API
 */
import request from "@/utils/request";

/**
 * 获取摄像头列表
 * @param {Object} data - 查询参数
 * @param {string} data.project_id - 项目 ID
 * @param {string} data.user_id - 用户 ID
 */
export function getCameraList(data) {
  return request({
    method: "get",
    url: "/project/camera/list",
    params: data,
    data: {},
  });
}

/**
 * 添加摄像头
 * @param {Object} data - 摄像头信息
 * @param {string} data.camera_name - 摄像头名称
 * @param {string} data.camera_type - 摄像头类型 (camera/network/local/other)
 * @param {string} data.rtsp_url - RTSP 地址
 * @param {string} data.username - 用户名
 * @param {string} data.password - 密码
 * @param {string} data.channel - 通道号
 * @param {string} data.ip_address - IP 地址
 * @param {number} data.port - 端口
 * @param {string} data.project_id - 项目 ID
 * @param {string} data.user_id - 用户 ID
 */
export function addCamera(data) {
  return request({
    method: "post",
    url: "/project/camera/add",
    data,
  });
}

/**
 * 删除摄像头
 * @param {Object} data - 删除参数
 * @param {string} data.camera_id - 摄像头 ID
 * @param {string} data.user_id - 用户 ID
 */
export function deleteCamera(data) {
  return request({
    method: "get",
    url: "/project/camera/delete",
    params: data,
    data: {},
  });
}

/**
 * 更新摄像头
 * @param {Object} data - 摄像头信息
 * @param {string} data.camera_id - 摄像头 ID
 * @param {string} data.camera_name - 摄像头名称
 * @param {string} data.rtsp_url - RTSP 地址
 * @param {string} data.username - 用户名
 * @param {string} data.password - 密码
 * @param {string} data.project_id - 项目 ID
 * @param {string} data.user_id - 用户 ID
 */
export function updateCamera(data) {
  return request({
    method: "post",
    url: "/project/camera/update",
    data,
  });
}

/**
 * 获取摄像头详情
 * @param {Object} data - 查询参数
 * @param {string} data.camera_id - 摄像头 ID
 * @param {string} data.user_id - 用户 ID
 */
export function getCameraDetail(data) {
  return request({
    method: "get",
    url: "/project/camera/detail",
    params: data,
    data: {},
  });
}

/**
 * 保存屏幕布局配置
 * @param {Object} data - 布局配置
 * @param {string} data.project_id - 项目 ID
 * @param {string} data.user_id - 用户 ID
 * @param {number|string} data.screen_mode - 屏幕模式 (1/4/9/carousel)
 * @param {Array} data.camera_slots - 摄像头位置配置 [{slot: 0, camera_id: 'xxx'}]
 */
export function saveScreenLayout(data) {
  return request({
    method: "post",
    url: "/project/camera/layout",
    data,
  });
}

/**
 * 获取屏幕布局配置
 * @param {Object} data - 查询参数
 * @param {string} data.project_id - 项目 ID
 * @param {string} data.user_id - 用户 ID
 */
export function getScreenLayout(data) {
  return request({
    method: "get",
    url: "/project/camera/layout",
    params: data,
    data: {},
  });
}

/**
 * 上传本地视频文件
 * @param {FormData} formData - 包含 video 文件的 FormData
 */
export function uploadVideo(formData) {
  return request({
    method: "post",
    url: "/project/camera/upload",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

/**
 * 检测单个摄像头在线状态
 * @param {Object} data - 查询参数
 * @param {string} data.camera_id - 摄像头 ID
 */
export function pingCamera(data) {
  return request({
    method: "get",
    url: "/project/camera/ping",
    params: data,
  });
}

/**
 * 批量检测摄像头在线状态
 * @param {Object} data - 项目 ID
 * @param {string} data.project_id - 项目 ID
 */
export function batchPingCameras(data) {
  return request({
    method: "post",
    url: "/project/camera/batch-ping",
    data,
  });
}

/**
 * 发现 ONVIF 设备
 */
export function discoverOnvifDevices() {
  return request({
    method: "get",
    url: "/project/camera/onvif/discover",
  });
}

/**
 * 添加 ONVIF 设备
 * @param {Object} data - ONVIF 设备信息
 */
export function addOnvifCamera(data) {
  return request({
    method: "post",
    url: "/project/camera/onvif/add",
    data,
  });
}

/**
 * 获取 RTMP 服务器配置
 */
export function getRtmpConfig() {
  return request({
    method: "get",
    url: "/project/camera/rtmp/config",
  });
}
